import type {Fond} from 'src/typings';
import type {FondedFieldType} from '../types';
import type {FondsDataService} from './fonds.data-service';

export class KpFondsService {
    public static serviceName = 'kpFondsService';

    /*@ngInject*/
    constructor(public fondsDataService: FondsDataService) {
    }

    public getAllFonds(): Promise<Fond[]> {
        return this.fondsDataService.getAll();
    }

    public getFondFieldTypes(fond: Fond): Promise<FondedFieldType[]> {
        return this.fondsDataService.getFondFieldTypes(fond.id);
    }
}